import {testXml} from './InverseXmlParsers'
import ReactDomServer from 'react-dom/server';

export default function SharedFolder(machine, measures){
    switch (machine) {
        case 'test': return ReactDomServer.renderToString(testXml(measures))
        case 'af300 nidek': return ReactDomServer.renderToString(testXml(measures))
        default: return null
    }
}